import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {Unit, UnitSearchParams} from '@accounting/_common/models/nomenclature-unit.models';

export const LoadList = createAction(
    '[Units] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Units] Load List Success',
    props<{ payload: { items: Unit[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Units] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetFilter = createAction(
    '[Units] Set Filter',
    props<{ payload: UnitSearchParams }>()
);

export const SetLoading = createAction(
    '[Units] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[Units] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[Units] Update Item Success',
    props<{ payload: Unit }>()
);

export const DeleteItem = createAction(
    '[Units] Delete Item',
    props<{ payload: Unit }>()
);

export const DeleteItemSuccess = createAction(
    '[Units] Delete Item Success',
    props<{ payload: Unit }>()
);

export const DeleteItemFailure = createAction(
    '[Units] Delete Item Failure',
    props<{ payload: Unit }>()
);

export const SetInitialState = createAction(
    '[Units] Set Initial State'
);
